import { FunctionComponent } from 'react';
import Chip from '@mui/material/Chip';
import { IDisabledChipProps } from './DisabledChip.interface';

export const DisabledChip: FunctionComponent<IDisabledChipProps> = ({ label, sx }) => {
  return (
    <Chip
      label={label}
      size={'small'}
      color={'default'}
      variant={'filled'}
      sx={sx}
    />
  );
};
